import { render, staticRenderFns } from "./AlertasBase.vue?vue&type=template&id=430edccd&"
import script from "./AlertasBase.vue?vue&type=script&lang=ts&"
export * from "./AlertasBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports